<script setup lang="ts">
import AppButton from "@/components/ui-kit/button/AppButton.vue"

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()
</script>

<template>
	<div class="move-all-confirm">
		<div class="move-all-confirm__title">Переместить все в историю?</div>
		<div class="move-all-confirm__description">
			Все новые уведомления будут перемещены в историю.
		</div>
		<div class="move-all-confirm__actions">
			<app-button
				class="move-all-confirm__actions-button"
				type="secondary"
				label="Отмена"
				@click="emit('cancel')"
			/>
			<app-button
				class="move-all-confirm__actions-button"
				label="Подтвердить"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.move-all-confirm {
	display: flex;
	flex-direction: column;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
